import { useState, useRef, useEffect } from "react";
import { searchReactivationCustomer } from "../../api/customer";
import { getReactivations } from "../../api/customer";

export function useReactivationListHooks({ filter }) {
  const [reactivations, setReactivations] = useState([]);
  const [meta, setMeta] = useState({ count: 0, page: 1, page_size: 10 });
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const getReactivationList = async (filter = {}) => {
    setLoading(true);
    setErrorMsg("");
    try {
      const { data } = await getReactivations({ ...filter });
      setReactivations(data.data);
      setMeta(data.pagination);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        setErrorMsg(data.message);
      } else {
        setErrorMsg("Something Error Happened");
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    getReactivationList(filter);
  }, [filter]);

  return {
    reactivations,
    meta,
    loading,
    errorMsg,
    getReactivationList,
  };
}

export function useSearchReactivationCustomer() {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const timeoutRef = useRef(null);

  const search = async (q) => {
    if (!q || q.length < 2) {
      setResults([]);
      setShowResults(false);
      return;
    }
    setLoading(true);
    try {
      const { data } = await searchReactivationCustomer({ q });
      setResults([data.data]);
      setShowResults(true);
    } catch (error) {
      setResults([]);
      setShowResults(true);
    }
    setLoading(false);
  };

  const handleQueryChange = (value) => {
    setQuery(value);
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => search(value), 300);
  };

  return {
    query,
    setQuery,
    results,
    loading,
    showResults,
    setShowResults,
    handleQueryChange,
  };
}
